module.exports = __webpack_public_path__ + "static/media/R-PANELv6.6-RC1/edit_VA.c7ee6724.svg";